import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {getLinkPath, isGuest, scrollToTop, isDesktop} from 'app/utils';
import {openAuth} from 'app/components/auth/auth';
import {PokerStore} from 'app/store/PokerStore';
import {inject, observer} from 'mobx-react';
import {restorePlayMoney} from 'app/components/user/menu';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    pokerStore?: PokerStore
    tableId: string
    playmoney: boolean
}

@inject('pokerStore')
@observer
export default class PokerMenuButtonDeposit extends React.Component<Props> {
    onClick = (): void => {
        scrollToTop();

        if (isGuest()) {
            openAuth();
        }

        if (!isDesktop()) {
            this.props.pokerStore.getTable(this.props.tableId).minimizeTable();
            document.body.classList.remove('body-overflow');
        }
    };

    render(): ReactNode {
        const {playmoney} = this.props;

        return <span className={`poker-button-go-deposit${playmoney ? ' pm' : ''}`}>
            {playmoney
                ? <a
                    href="#"
                    onClick={restorePlayMoney}
                    title={I18n.t('restore_play_money')}
                >
                    <SpriteIcon name="#svg-refresh" id="prevent-close"/>
                </a>
                : <Link
                    to={getLinkPath('/deposits')}
                    onClick={this.onClick}
                >
                    <svg className="svg-default plus"><use xlinkHref="#svg-add"/></svg>
                </Link>}
        </span>;
    }
}
